import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "madrid-loading"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "madrid-location-data__header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "madrid-location-data__author madrid-location-data__author-ant"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "madrid-location-data__author"
}
const _hoisted_8 = { class: "madrid-location-data__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_madrid_quiz = _resolveComponent("madrid-quiz")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                id: "loading",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                x: "0px",
                y: "0px",
                viewBox: "0 -24 60 48",
                "enable-background": "new 0 0 0 0",
                "xml:space": "preserve"
              }, [
                _createElementVNode("circle", {
                  fill: "#fff",
                  stroke: "none",
                  cx: "6",
                  cy: "0",
                  r: "6"
                }, [
                  _createElementVNode("animateTransform", {
                    attributeName: "transform",
                    dur: "1s",
                    type: "translate",
                    values: "0 15 ; 0 -15; 0 15",
                    repeatCount: "indefinite",
                    begin: "0.1"
                  })
                ]),
                _createElementVNode("circle", {
                  fill: "#fff",
                  stroke: "none",
                  cx: "30",
                  cy: "0",
                  r: "6"
                }, [
                  _createElementVNode("animateTransform", {
                    attributeName: "transform",
                    dur: "1s",
                    type: "translate",
                    values: "0 10 ; 0 -10; 0 10",
                    repeatCount: "indefinite",
                    begin: "0.2"
                  })
                ]),
                _createElementVNode("circle", {
                  fill: "#fff",
                  stroke: "none",
                  cx: "54",
                  cy: "0",
                  r: "6"
                }, [
                  _createElementVNode("animateTransform", {
                    attributeName: "transform",
                    dur: "1s",
                    type: "translate",
                    values: "0 5 ; 0 -5; 0 5",
                    repeatCount: "indefinite",
                    begin: "0.3"
                  })
                ])
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("iframe", {
      id: "visor",
      ref: "onirixIframe",
      style: _normalizeStyle(
                _ctx.computedStyle
            ),
      src: _ctx.url,
      allow: "web-share;camera;gyroscope;accelerometer;magnetometer;fullscreen;xr-spatial-tracking;geolocation;"
    }, null, 12, _hoisted_2),
    (_ctx.showData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["madrid-location-data", {'madrid-location-data--ar': _ctx.currentLocation.ar}])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "madrid-location-data__back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            }),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.route.name), 1),
              _createElementVNode("span", null, "PARADA " + _toDisplayString(_ctx.index + 1), 1)
            ]),
            _createElementVNode("h1", null, _toDisplayString(_ctx.currentLocation.name), 1)
          ]),
          (_ctx.currentLocation.image_ant != '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "madrid-location-data__image",
                src: _ctx.currentLocation.image_ant
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.currentLocation.author_ant)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _cache[3] || (_cache[3] = _createTextVNode("Foto antes: ")),
                _createElementVNode("span", null, _toDisplayString(_ctx.currentLocation.author_ant), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            class: "madrid-location-data__image",
            src: _ctx.currentLocation.image
          }, null, 8, _hoisted_6),
          (_ctx.currentLocation.author)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _cache[4] || (_cache[4] = _createTextVNode("Foto después: ")),
                _createElementVNode("span", null, _toDisplayString(_ctx.currentLocation.author), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.currentLocation.description), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToTop()))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, "VOLVER ARRIBA", -1),
              _createElementVNode("span", null, null, -1)
            ])),
            _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showQuiz)
      ? (_openBlock(), _createBlock(_component_madrid_quiz, {
          key: 1,
          onGoTo: _ctx.hideQuiz,
          route: _ctx.route.name,
          type: _ctx.QuizType.FINAL,
          location: _ctx.currentLocation.name
        }, null, 8, ["onGoTo", "route", "type", "location"]))
      : _createCommentVNode("", true)
  ]))
}